import { contactsConstants } from '@constants/contacts';
import { ModalType } from '@constants/modal';

const initialState = {
    data: [],
    loading: true,
    totalCount: 0,
    pages: 1,
    contact: null,
    contactDrawerOpened: false,
    searchedContacts: [],
    bulkEditData: {},
    contactDeleteModal: false,
    contactEditModal: { open: false, type: ModalType.Create },
    contactMergeModal: false,
    contactInitConversationModal: { open: false, contactId: null, companies: [], ctx: null },
};

export function contacts(state = initialState, action) {
    switch (action.type) {
        case contactsConstants.CONTACTS_FETCH:
            return { ...state };
        case contactsConstants.CONTACTS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data.items,
                totalCount: action.data.totalCount,
                pages: action.data.pages,
            };
        case contactsConstants.SEARCHED_CONTACTS_SUCCESS:
            return {
                ...state,
                loading: false,
                searchedContacts: action.data.items,
                totalCount: action.data.totalCount,
                pages: action.data.pages,
            };
        case contactsConstants.RESET_CONTACTS:
            return { ...state, data: [], totalCount: 0, pages: 1, loading: true };
        case contactsConstants.SEARCHED_CONTACTS_RESET:
            return { ...state, searchedContacts: [] };
        case contactsConstants.CONTACTS_ERROR:
            return { ...state, loading: false };
        case contactsConstants.SET_CONTACTS:
            return { ...state, data: action.data };
        case contactsConstants.BULK_EDIT_DATA_SUCCESS:
            return { ...state, bulkEditData: action.data };
        case contactsConstants.SET_CONTACT_LOADING:
            return { ...state, contact: null };
        case contactsConstants.SET_CONTACT:
            return { ...state, contact: action.data };
        case contactsConstants.SET_CONTACT_DRAWER:
            return { ...state, contactDrawerOpened: action.payload };
        case contactsConstants.SET_CONTACT_DELETE_MODAL:
            return { ...state, contactDeleteModal: action.payload };
        case contactsConstants.SET_CONTACT_EDIT_MODAL:
            return { ...state, contactEditModal: action.payload };
        case contactsConstants.SET_CONTACT_MERGE_MODAL:
            return { ...state, contactMergeModal: action.payload };
        case contactsConstants.SET_CONTACT_INIT_CONVERSATION_MODAL:
            return { ...state, contactInitConversationModal: action.payload };
        default:
            return state;
    }
}
